import { useState } from 'react';
import { useCurrentUser } from '../hooks/useCurrentUser';
import LoginModal from '../components/LoginModal';

const SCORER_ROLES = ['scorer', 'admin', 'super_admin', 'manager'];

export function ScorerAuthGate({ children }: { children: React.ReactNode }) {
  const { user, loading } = useCurrentUser();
  const [showLogin, setShowLogin] = useState(false);

  const isAuthed = user?.isActive && SCORER_ROLES.includes(user.role);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-golf-orange border-t-transparent" />
      </div>
    );
  }

  if (!isAuthed) {
    return (
      <div className="px-4 py-16 text-center">
        <div className="w-16 h-16 rounded-full bg-golf-orange/10 flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-golf-orange" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <h2 className="text-lg font-bold text-golf-gray mb-2">Scorer Login Required</h2>
        <p className="text-sm text-gray-500 mb-6 max-w-xs mx-auto">
          You must be signed in as a scorer or admin to access this area.
        </p>
        <button
          onClick={() => setShowLogin(true)}
          className="px-6 py-3 bg-golf-orange text-white font-semibold rounded-xl text-sm"
        >
          Sign In
        </button>
        <LoginModal isOpen={showLogin} onClose={() => setShowLogin(false)} />
      </div>
    );
  }

  return <>{children}</>;
}
